import { RMCustomButtonProps } from 'components/customComponents/CommonComponents/RMCustomButton/RMCustomButton';
import { IDropDownList } from 'components/customComponents/CommonComponents/RMDropDownList';
import { MenuItem } from 'components/dropdowns/RMDropdown';
import ECompareMode from 'enums/ECompareMode';
import { EFileExportTypes, EFileImportTypes } from 'enums/EFileExportTypes';
import EIconPanels, { EReportTypes } from 'enums/EIconPanels';
import { hasModifyAccess } from 'utils/accessRights';
import React from 'react';
import {
  DropDownListButtonsColor,
  GetHeaderHeight,
  headerButtonsColor,
  headerIconSize,
  showAlertSnackBar,
} from 'utils/Global';
import { RMSvgIconNames } from 'components/customComponents/CommonComponents/RMSvgIcon';
import { EUserAction } from 'constants/index';
import {
  BooleanPropertyDTO,
  CreateNewTreeNodeDTO,
  EPoiExportType,
  LayerTypeDTO,
  NavigatorMapDTO,
  PlateWellDTO,
  PreferenesDTO,
  RotateScreenDTO,
} from 'business/models/Models';
import EAlertType from 'enums/EAlertType';
import ESnackBarPosition from 'enums/ESnackBarPosition';
import ScreenService from 'business/services/ScreenService';
import { TreeService } from 'business/services/TreeService';
import { GlobalPreferencesService } from 'business/services/GlobalPreferencesService';
import { PropertyConstants } from 'enums/PropertyConstants';
import { WellNavigationDetails, RotatedScreenNameRegex } from './constants';
import { PrintType } from 'components/main/constants';
import ETreeNodeTypes from 'enums/ETreeNodeTypes';
import { experiment } from 'components/main/utils';
import { TreeNode } from 'utils/ExperimentUtils';

export type GetAddLayerListParams = {
  accessRightName: string;
  isEditMode: boolean;
  isScreenMode: boolean;
  changeIconPanels: (panel: EIconPanels, isLicenseViolation?: boolean) => void;
  authCommand: (
    command: any,
    action: EUserAction,
  ) => (panel: EIconPanels, isLicenseViolation?: boolean) => void;
  isScreenInUse: boolean;
  openLayersExplorerPanel: () => void;
};

export type GetDesignExtraButtonsListParams = {
  accessRightName: string;
  isEditMode: boolean;
  setFileImportActionType: (actionType: EFileImportTypes) => void;
  setFileExportActionType: (actionType: EFileExportTypes) => void;
  isDisabled: boolean;
  rotateCanvas?: () => void;
  markAsDispensed?: () => void;
  isDispensed?: boolean;
  isScreenExperiment?: boolean;
};

export type GetDesignHeaderButtonsParams = {
  editExperiment: () => void;
  showOptimizationModal: (flag: boolean) => void;
  printBarcode: () => void;
  addLayerList: IDropDownList[];
  reportsList: IDropDownList[];
  printActionsList: IDropDownList[];
  setFileImportActionType: (actionType: EFileImportTypes) => void;
  setFileExportActionType: (actionType: EFileExportTypes) => void;
  accessRightName;
  isEditMode;
  isDisabled: boolean;
  isIngredientView: boolean;
  markAsDispensed?: () => void;
  isDispensed?: boolean;
  disablePrintBarcode: boolean;
  isEditingAllowed: boolean;
  isRMLite: boolean;
};

export type GetImageHeaderButtonsParams = {
  saveImage: () => void;
  changeIconPanels: (e) => void;
  ShowOptimizeModalHandler: () => void;
  reportsList: IDropDownList[];
  accessRightName: string;
  setFileExportActionType: (actionType: EFileExportTypes) => void;
  exportPoi: () => void;
  deleteInspection: () => void;
  createSeedHandler: (flag: boolean) => void;
  isDisabled: boolean;
  getDisableImageLabel: () => string;
  setRegionImaging: (e) => void;
  rmLite?: boolean;
  manageImaging: () => void;
};

export type GetImageHeaderExtraButtonsParams = {
  accessRightName: string;
  setFileExportActionType: (actionType: EFileExportTypes) => void;
  exportPoi: () => void;
  deleteInspection: () => void;
  getDisableImageLabel: () => string;
  setRegionImaging: (e) => void;
  manageImaging: () => void;
};

export type GetScoreHeaderButtonsParams = {
  ShowOptimizeModalHandler: () => void;
  reportsList: IDropDownList[];
  accessRightName: string;
  setFileExportActionType: (actionType: EFileExportTypes) => void;
  exportPoi: () => void;
  isDisabled: boolean;
  rmLite?: boolean;
};

export type GetScoreHeaderExtraButtonsParams = {
  accessRightName: string;
  setFileExportActionType: (actionType: EFileExportTypes) => void;
  exportPoi: () => void;
};

export type GetInfoHeaderButtonsParams = {
  reportsList: IDropDownList[];
  barcodeActionsList: IDropDownList[];
  printBarcode: () => void;
  isDisabled: boolean;
  disablePrintBarcode: boolean;
  rmLite: boolean;
};
export type GetReportsButtonsListParams = {
  setReportType: (reportType: EReportTypes) => void;
  usageStatLogger: (feature: string) => void;
  accessRightName: string;
  GetDisplayMode: () => string;
  licenseAuthCommand: (command: any, action: EUserAction) => any;
  SetDisplayMode: (mode: string) => void;
  exportFrapDataPoints: () => void;
  disableFrapExport?: boolean;
};

export type GetScreenDesignExtraButtonsListParams = {
  accessRightName: string;
  setFileExportActionType: (actionType: EFileExportTypes) => void;
  setFileImportActionType: (actionType: EFileImportTypes) => void;
};

export type GetScreenDesignHeaderButtonsParams = {
  addLayerList: IDropDownList[];
  accessRightName: string;
  setFileExportActionType: (actionType: EFileExportTypes) => void;
  setFileImportActionType: (actionType: EFileImportTypes) => void;
  showOptimizationModal: (flag: boolean) => void;
  printBarcode: () => void;
  reportsList: IDropDownList[];
  printActionsList: IDropDownList[];
  isDisabled: boolean;
  rotateCanvas: () => void;
  disablePrintBarcode: boolean;
};

export type GetWellImageExtraActionsParams = {
  accessRightName: string;
  saveImage: () => void;
  setFileExportActionType: (actionType: EFileExportTypes) => void;
  getDisableImageLabel: () => string;
  setRegionImaging: (e) => void;
  exportPoi?: (exportType?: EPoiExportType) => void;
  isDropImageAvailable?: boolean;
};

export type GetWellImageHeaderButtonsParams = {
  isCompareMode: boolean;
  isWellMode: boolean;
  compareModeHandler: (e) => void;
  accessRightName: string;
  ShowOptimizeModalHandler: (flag: boolean) => void;
  createSeedHandler: (flag: boolean) => void;
  saveImage: () => void;
  reportsList: IDropDownList[];
  setFileExportActionType: (actionType: EFileExportTypes) => void;
  isDisabled: boolean;
  getDisableImageLabel: () => string;
  setRegionImaging: (e) => void;
  rmLite?: boolean;
  exportPoi?: (exportType?: EPoiExportType) => void;
  isDropImageAvailable?: boolean;
  selectedCompareMode?: ECompareMode;
};

export type GetIngredientHeaderButtonsParams = {
  printBarcode: () => void;
  isDisabled: boolean;
};

const validLayers = ['Grid Layer', 'Custom Layer', 'Random Layer', 'Explore'];
const screenReports = ['Design', 'Ingredient', 'Screen Stock'];
export const screenStockReportLabel = 'Screen Stock';

export const getAddLayerList = (params: GetAddLayerListParams) => {
  const {
    accessRightName,
    isEditMode,
    changeIconPanels,
    isScreenMode,
    authCommand,
    isScreenInUse,
    openLayersExplorerPanel,
  } = params;
  const AddLayerList: IDropDownList[] = [
    {
      label: 'Explore',
      iconProps: {
        name: 'Explore',
        fill: DropDownListButtonsColor,
      },
      onClick: openLayersExplorerPanel,
      isDisabled: !hasModifyAccess(accessRightName) || !isEditMode || isScreenInUse,
      addSeparator: true,
    },
    {
      label: 'Grid Layer',
      iconProps: {
        subfolder: 'Layers',
        name: 'GridLayer',
        fill: DropDownListButtonsColor,
      },
      onClick: authCommand(
        () => changeIconPanels(EIconPanels.GridLayer),
        EUserAction.GridLayer,
      ),
      isDisabled: !hasModifyAccess(accessRightName) || !isEditMode || isScreenInUse,
    },
    {
      label: 'Random Layer',
      iconProps: {
        subfolder: 'Layers',
        name: 'RandomLayer',
        fill: DropDownListButtonsColor,
      },
      onClick: authCommand(
        () => changeIconPanels(EIconPanels.RandomLayer),
        EUserAction.RandomLayer,
      ),
      isDisabled: !hasModifyAccess(accessRightName) || !isEditMode || isScreenInUse,
    },
    {
      label: 'Custom Layer',
      iconProps: {
        subfolder: 'Layers',
        name: 'CustomLayer',
        fill: DropDownListButtonsColor,
      },
      onClick: authCommand(
        () => changeIconPanels(EIconPanels.CustomLayer),
        isScreenMode ? EUserAction.CustomLayerScreen : EUserAction.CustomLayer,
      ),
      isDisabled: !hasModifyAccess(accessRightName) || !isEditMode || isScreenInUse,
    },
    {
      label: 'Protein Layer',
      iconProps: {
        subfolder: 'Layers',
        name: 'ProteinLayer',
        fill: DropDownListButtonsColor,
      },
      onClick: authCommand(
        () => changeIconPanels(EIconPanels.ProtienLayer),
        EUserAction.ProtienLayer,
      ),
      isDisabled: !hasModifyAccess(accessRightName) || !isEditMode,
    },
    {
      label: 'Seeding Layer',
      iconProps: {
        subfolder: 'Layers',
        name: 'SeedingLayer',
        fill: DropDownListButtonsColor,
      },
      onClick: authCommand(
        () => changeIconPanels(EIconPanels.SeedingLayer),
        EUserAction.SeedingLayer,
      ),
      isDisabled: !hasModifyAccess(accessRightName) || !isEditMode,
    },
    {
      label: 'Screen Layer',
      iconProps: { name: 'Screen', fill: DropDownListButtonsColor },
      onClick: authCommand(
        () => changeIconPanels(EIconPanels.ScreenLayer),
        EUserAction.ScreenLayer,
      ),
      isDisabled: !hasModifyAccess(accessRightName) || !isEditMode,
    },
    {
      label: 'Fragment Layer',
      iconProps: { name: 'FragmentScreen', fill: DropDownListButtonsColor },
      onClick: authCommand(
        () => changeIconPanels(EIconPanels.FragmentLayer),
        EUserAction.FragmentLayer,
      ),
      isDisabled: !hasModifyAccess(accessRightName) || !isEditMode,
    },
  ];
  return AddLayerList;
};

export const getPrintActionsList = (
  printBarcode: (printType: PrintType) => void,
): IDropDownList[] => {
  const printActionsList: IDropDownList[] = [
    {
      iconProps: { name: 'PrintBatchLoadExpBarcode' },
      label: 'Print Experiment Barcode',
      onClick: () => printBarcode(PrintType.ExperimentBarcode),
      titleTip: 'Print Experiment Barcode',
    },
    {
      iconProps: { name: 'PrintExperimentInfo' },
      label: 'Print Experiment Info',
      onClick: () => printBarcode(PrintType.ExperimentInformation),
      titleTip: 'Print Experiment Information',
    },
  ];
  return printActionsList;
};

export const getBarcodeActionsList = (
  onEditBarcode: () => void,
  printBarcode: (printType: PrintType) => void,
  options?: { isEditBarcodeDisabled?: boolean },
): IDropDownList[] => {
  return [
    {
      iconProps: { name: 'Edit', fill: DropDownListButtonsColor },
      label: 'Edit Barcode',
      onClick: onEditBarcode,
      titleTip: 'Edit Barcode',
      isDisabled: options?.isEditBarcodeDisabled,
    },
    ...getPrintActionsList(printBarcode),
  ];
};

export const getViewByList = (
  compareModeHandler: (e) => void,
  selectedCompareMode: ECompareMode,
  isWellMode = false,
) => {
  const compareList: IDropDownList[] = [
    {
      label: 'Single Row',
      iconProps: { name: 'CompareRow', fill: DropDownListButtonsColor },
      onClick: () => compareModeHandler(ECompareMode.Row),
      itemClass:
        selectedCompareMode === ECompareMode.Row ? 'rm-drop-down-list-row-selected' : '',
    },
    {
      label: isWellMode ? 'Grid View' : '2 x 2 Grid',
      iconProps: { name: 'CompareGrid', fill: DropDownListButtonsColor },
      onClick: () => compareModeHandler(ECompareMode.Grid),
      itemClass:
        selectedCompareMode === ECompareMode.Grid ? 'rm-drop-down-list-row-selected' : '',
    },
    {
      label: 'Overlay',
      iconProps: { name: 'Overlay', fill: DropDownListButtonsColor },
      onClick: () => compareModeHandler(ECompareMode.Overlay),
      itemClass:
        selectedCompareMode === ECompareMode.Overlay
          ? 'rm-drop-down-list-row-selected'
          : '',
    },
  ];
  return compareList;
};

export const getDesignExtraButtonsList = (params: GetDesignExtraButtonsListParams) => {
  const {
    accessRightName,
    isEditMode,
    setFileImportActionType,
    setFileExportActionType,
    isDisabled,
    rotateCanvas,
    markAsDispensed,
    isDispensed,
    isScreenExperiment,
  } = params;
  const extraOptionsList: IDropDownList[] = [];

  if (rotateCanvas) {
    extraOptionsList.push({
      label: 'Rotate Canvas',
      iconProps: { name: 'RotateCanvas', fill: DropDownListButtonsColor },
      onClick: rotateCanvas,
      isDisabled: !rotateCanvas || !hasModifyAccess(accessRightName) || isDisabled,
    });
  }

  if (!isScreenExperiment) {
    extraOptionsList.push({
      label: 'Mark as Dispensed',
      iconProps: { name: 'ConvertToScreen', fill: DropDownListButtonsColor },
      onClick: markAsDispensed,
      isDisabled:
        isDispensed ||
        !markAsDispensed ||
        !hasModifyAccess(accessRightName) ||
        isDisabled,
    });
  }

  extraOptionsList.push(
    {
      label: 'Import XML Screen',
      iconProps: { name: 'Import', fill: DropDownListButtonsColor },
      onClick: () => setFileImportActionType(EFileImportTypes.XMLSCREEN),
      isDisabled: !isEditMode || !hasModifyAccess(accessRightName),
    },
    {
      label: 'Import Fluidigm Screen',
      iconProps: { name: 'Import', fill: DropDownListButtonsColor },
      onClick: () => {},
      isDisabled: true,
    },
    {
      label: 'Import Text File',
      iconProps: { name: 'Import', fill: DropDownListButtonsColor },
      onClick: () => setFileImportActionType(EFileImportTypes.TEXT),
      isDisabled: !isEditMode || !hasModifyAccess(accessRightName),
    },
    {
      label: 'Export XML Screen',
      iconProps: { name: 'Export', fill: DropDownListButtonsColor },
      onClick: () => setFileExportActionType(EFileExportTypes.XMLSCREEN),
      isDisabled: !hasModifyAccess(accessRightName),
    },
    {
      label: 'Export Selected Well (TXT)',
      iconProps: { name: 'Export', fill: DropDownListButtonsColor },
      onClick: () => setFileExportActionType(EFileExportTypes.Text),
      isDisabled: !hasModifyAccess(accessRightName),
    },
  );

  return extraOptionsList;
};

export const getDesignHeaderButtons = (params: GetDesignHeaderButtonsParams) => {
  const {
    editExperiment,
    showOptimizationModal,
    addLayerList,
    reportsList,
    printActionsList,
    setFileImportActionType,
    setFileExportActionType,
    accessRightName,
    isEditMode,
    isDisabled,
    isIngredientView,
    markAsDispensed,
    isDispensed,
    disablePrintBarcode,
    isEditingAllowed,
    isRMLite,
  } = params;

  if (isRMLite) {
    return [];
  }

  const designExtraButtonsListParams: GetDesignExtraButtonsListParams = {
    accessRightName,
    isEditMode,
    setFileImportActionType,
    setFileExportActionType,
    isDisabled,
    markAsDispensed,
    isDispensed,
    isScreenExperiment: false,
  };
  const designExtraButtonsList = getDesignExtraButtonsList(designExtraButtonsListParams);

  const designHeaderButtons: Array<RMCustomButtonProps> = [
    !isIngredientView && {
      iconProps: { name: 'AddLayer', fill: headerButtonsColor, ...headerIconSize },
      title: 'Add Layer',
      isDisabled: isDisabled,
      dropDownList: addLayerList,
      color: headerButtonsColor,
      showChevronIcon: true,
      chevronIconInitialAngle: 315,
      chevronIconPosition: 'end',
      contentOrientation: 'Vertical',
      contentContainerClass: 'header-button-container main-header-extended-button',
      titleClass: 'header-button-title',
    },
    isEditingAllowed &&
      !isIngredientView && {
        iconProps: {
          name: 'EditExperiment',
          fill: headerButtonsColor,
          ...headerIconSize,
        },
        title: 'Edit',
        /***
         * todo: Centeralize Experiment edit logic
         */
        isDisabled: !hasModifyAccess(accessRightName) || isEditMode || isDisabled,
        contentOrientation: 'Vertical',
        contentContainerClass: 'header-button-container',
        titleClass: 'header-button-title',
        onClick: editExperiment,
      },
    {
      iconProps: { name: 'PrintBarcode', fill: headerButtonsColor, ...headerIconSize },
      title: 'Barcode',
      isDisabled: isDisabled || disablePrintBarcode,
      dropDownList: printActionsList,
      color: headerButtonsColor,
      showChevronIcon: true,
      chevronIconInitialAngle: 315,
      chevronIconPosition: 'end',
      contentOrientation: 'Vertical',
      contentContainerClass: 'header-button-container main-header-extended-button',
      titleClass: 'header-button-title',
    },
    {
      iconProps: { name: 'Optimize', fill: headerButtonsColor, ...headerIconSize },
      title: 'Optimize',
      contentOrientation: 'Vertical',
      contentContainerClass: 'header-button-container',
      titleClass: 'header-button-title',
      onClick: showOptimizationModal,
      isDisabled: isDisabled || !hasModifyAccess(accessRightName),
    },
    {
      iconProps: {
        subfolder: 'Reports',
        name: 'Report',
        fill: headerButtonsColor,
        ...headerIconSize,
      },
      title: 'Reports',
      isDisabled: isDisabled,
      dropDownList: reportsList.filter((item) => item.label != screenStockReportLabel),
      color: headerButtonsColor,
      showChevronIcon: true,
      chevronIconInitialAngle: 315,
      chevronIconPosition: 'end',
      contentOrientation: 'Vertical',
      contentContainerClass: 'header-button-container main-header-extended-button',
      titleClass: 'header-button-title',
    },
    {
      iconProps: { name: 'ThreeDotMenu', fill: headerButtonsColor, ...headerIconSize },
      title: 'More',
      isDisabled: isDisabled,
      dropDownList: designExtraButtonsList,
      color: headerButtonsColor,
      showChevronIcon: true,
      chevronIconInitialAngle: 315,
      chevronIconPosition: 'end',
      contentOrientation: 'Vertical',
      contentContainerClass: 'header-button-container main-header-extended-button',
      titleClass: 'header-button-title',
    },
  ];

  return designHeaderButtons;
};

export type PoiExportFormatOption = {
  label: string;
  exportType: EPoiExportType;
  isDisabled?: boolean;
};

export const POI_EXPORT_FORMATS: PoiExportFormatOption[] = [
  { label: 'Default', exportType: EPoiExportType.Default },
  { label: 'Echo', exportType: EPoiExportType.EchoRobot },
  { label: 'Crystal Shifter', exportType: EPoiExportType.CrystalShifter },
  { label: 'SoakDB', exportType: EPoiExportType.SoakDB },
];

export const getPoiExportSubMenu = (
  onExport: (exportType: EPoiExportType) => void,
): IDropDownList[] =>
  POI_EXPORT_FORMATS.map(({ label, exportType, isDisabled }) => ({
    label,
    isDisabled,
    onClick: () => onExport(exportType),
  }));

export const getPoiExportSubmenuItems = (
  onExport: (exportType: EPoiExportType) => void,
): MenuItem[] =>
  POI_EXPORT_FORMATS.map(({ label, exportType, isDisabled }) => ({
    label,
    isDisabled,
    onClick: () => onExport(exportType),
  }));

type ExportPoiFn = (
  expId: number,
  plateId: number | null,
  wellNum: number | null,
  dropNumber: number | null,
  regionId: number | null,
  isDropModeUrl: boolean,
  exportType?: EPoiExportType,
  plateIds?: number[] | null,
) => Promise<void>;

const MULTI_POI_EXPORT_GAP_MS = 300;

export function getSelectedExperimentIds(
  nodes: Array<{ type?: string; extra?: { id?: number } | null }> | null | undefined,
): number[] {
  return (nodes ?? []).flatMap((node) => {
    const experimentId = node?.extra?.id;
    return node?.type === ETreeNodeTypes.Experiment && experimentId != null
      ? [Number(experimentId)]
      : [];
  });
}

export async function exportPoiForExperiments(
  experimentIds: number[],
  exportType: EPoiExportType,
  exportPoi: ExportPoiFn,
  getPlateIds: (experimentId: number) => number[] | null = () => null,
  gapMs = MULTI_POI_EXPORT_GAP_MS,
): Promise<void> {
  for (let index = 0; index < experimentIds.length; index += 1) {
    const experimentId = experimentIds[index];
    await exportPoi(
      experimentId,
      null,
      null,
      null,
      null,
      false,
      exportType,
      getPlateIds(experimentId),
    );
    if (index < experimentIds.length - 1 && gapMs > 0) {
      await new Promise((resolve) => setTimeout(resolve, gapMs));
    }
  }
}

type ExportExtraButtonsParams = {
  accessRightName: string;
  setFileExportActionType: (actionType: EFileExportTypes) => void;
  exportPoi: (exportType?: EPoiExportType) => void;
};

const getExportExtraButtons = (params: ExportExtraButtonsParams): IDropDownList[] => {
  const { accessRightName, setFileExportActionType, exportPoi } = params;
  return [
    {
      label: 'Export POI',
      iconProps: { name: 'ExportPOI', fill: DropDownListButtonsColor },
      subMenu: getPoiExportSubMenu(exportPoi),
    },
    {
      label: 'Export XML Screen',
      iconProps: { name: 'Export', fill: DropDownListButtonsColor },
      onClick: () => {
        setFileExportActionType(EFileExportTypes.XMLSCREEN);
      },
      isDisabled: !hasModifyAccess(accessRightName),
    },
    {
      label: 'Export Selected Well (TXT)',
      iconProps: { name: 'Export', fill: DropDownListButtonsColor },
      onClick: () => {
        setFileExportActionType(EFileExportTypes.Text);
      },
      isDisabled: !hasModifyAccess(accessRightName),
    },
  ];
};

const buildOptimizeButton = (
  ShowOptimizeModalHandler: () => void,
  isDisabled: boolean,
  accessRightName: string,
): RMCustomButtonProps => ({
  iconProps: { name: 'Optimize', fill: headerButtonsColor, ...headerIconSize },
  title: 'Optimize',
  isDisabled: isDisabled || !hasModifyAccess(accessRightName),
  contentOrientation: 'Vertical',
  contentContainerClass: 'header-button-container',
  titleClass: 'header-button-title',
  onClick: ShowOptimizeModalHandler,
});

const buildReportsButton = (
  reportsList: IDropDownList[],
  isDisabled: boolean,
): RMCustomButtonProps => ({
  iconProps: {
    subfolder: 'Reports',
    name: 'Report',
    fill: headerButtonsColor,
    ...headerIconSize,
  },
  title: 'Reports',
  isDisabled: isDisabled,
  dropDownList: reportsList.filter((item) => item.label != screenStockReportLabel),
  color: headerButtonsColor,
  showChevronIcon: true,
  chevronIconInitialAngle: 315,
  chevronIconPosition: 'end',
  contentOrientation: 'Vertical',
  contentContainerClass: 'header-button-container main-header-extended-button',
  titleClass: 'header-button-title',
});

const buildMoreButton = (
  dropDownList: IDropDownList[],
  isDisabled: boolean,
): RMCustomButtonProps => ({
  iconProps: { name: 'ThreeDotMenu', fill: headerButtonsColor, ...headerIconSize },
  title: 'More',
  isDisabled: isDisabled,
  dropDownList,
  color: headerButtonsColor,
  showChevronIcon: true,
  chevronIconInitialAngle: 315,
  chevronIconPosition: 'end',
  contentOrientation: 'Vertical',
  contentContainerClass: 'header-button-container main-header-extended-button',
  titleClass: 'header-button-title',
});

export const getImageHeaderButtons = (params: GetImageHeaderButtonsParams) => {
  const {
    saveImage,
    ShowOptimizeModalHandler,
    reportsList,
    accessRightName,
    setFileExportActionType,
    exportPoi,
    deleteInspection,
    createSeedHandler,
    isDisabled,
    getDisableImageLabel,
    setRegionImaging,
    rmLite,
    manageImaging,
  } = params;

  const imageHeaderExtraButtons = getImageHeaderExtraButtons({
    accessRightName,
    setFileExportActionType,
    exportPoi,
    deleteInspection,
    getDisableImageLabel,
    setRegionImaging,
    manageImaging,
  });
  const optimizeButton = buildOptimizeButton(
    ShowOptimizeModalHandler,
    isDisabled,
    accessRightName,
  );
  const reportsButton = buildReportsButton(reportsList, isDisabled);
  const moreButton = buildMoreButton(imageHeaderExtraButtons, isDisabled);

  if (rmLite) {
    return [
      {
        title: 'Save',
        isDisabled: isDisabled,
        iconProps: { name: 'SaveImage', fill: headerButtonsColor, ...headerIconSize },
        contentOrientation: 'Vertical',
        contentContainerClass: 'header-button-container',
        titleClass: 'header-button-title',
        onClick: saveImage,
      },
    ];
  }

  const imageHeaderButtons: Array<RMCustomButtonProps | React.ReactNode> = [
    {
      title: 'Save',
      isDisabled: isDisabled,
      iconProps: { name: 'SaveImage', fill: headerButtonsColor, ...headerIconSize },
      contentOrientation: 'Vertical',
      contentContainerClass: 'header-button-container',
      titleClass: 'header-button-title',
      onClick: saveImage,
    },
    optimizeButton,
    {
      title: 'Seed',
      isDisabled: isDisabled,
      iconProps: { name: 'AddSeed', fill: headerButtonsColor, ...headerIconSize },
      contentOrientation: 'Vertical',
      contentContainerClass: 'header-button-container',
      titleClass: 'header-button-title',
      onClick: createSeedHandler,
    },
    reportsButton,
    moreButton,
  ];

  return imageHeaderButtons;
};

export const getImageHeaderExtraButtons = (params: GetImageHeaderExtraButtonsParams) => {
  const {
    accessRightName,
    setFileExportActionType,
    exportPoi,
    deleteInspection,
    manageImaging,
  } = params;
  const exportButtons = getExportExtraButtons({
    accessRightName,
    setFileExportActionType,
    exportPoi,
  });
  const ImageHeaderExtraButtons: IDropDownList[] = [
    {
      label: 'Manage Imaging',
      iconProps: { name: 'ImageManage', fill: DropDownListButtonsColor },
      onClick: manageImaging,
      isDisabled: false,
    },
    {
      label: 'Add Images',
      iconProps: { name: 'AddImage', fill: DropDownListButtonsColor },
      onClick: () => {},
      isDisabled: true,
    },
    {
      label: 'Create New Inspection',
      iconProps: { name: 'CreateInspection', fill: DropDownListButtonsColor },
      onClick: () => {},
      isDisabled: true,
    },
    {
      label: 'Delete Inspection',
      iconProps: { name: 'DeleteInspection', fill: DropDownListButtonsColor },
      onClick: deleteInspection,
    },
    ...exportButtons,
  ];
  return ImageHeaderExtraButtons;
};

export const getScoreHeaderButtons = (params: GetScoreHeaderButtonsParams) => {
  const {
    ShowOptimizeModalHandler,
    reportsList,
    accessRightName,
    setFileExportActionType,
    exportPoi,
    isDisabled,
    rmLite,
  } = params;

  const scoreHeaderExtraButtons = getScoreHeaderExtraButtons({
    accessRightName,
    setFileExportActionType,
    exportPoi,
  });
  const optimizeButton = buildOptimizeButton(
    ShowOptimizeModalHandler,
    isDisabled,
    accessRightName,
  );
  const reportsButton = buildReportsButton(reportsList, isDisabled);
  const moreButton = buildMoreButton(scoreHeaderExtraButtons, isDisabled);

  if (rmLite) {
    return [];
  }

  const scoreHeaderButtons: Array<RMCustomButtonProps | React.ReactNode> = [
    optimizeButton,
    reportsButton,
    moreButton,
  ];

  return scoreHeaderButtons;
};

export const getScoreHeaderExtraButtons = (params: GetScoreHeaderExtraButtonsParams) => {
  const { accessRightName, setFileExportActionType, exportPoi } = params;
  return getExportExtraButtons({
    accessRightName,
    setFileExportActionType,
    exportPoi,
  });
};

export const getInfoHeaderButtons = (params: GetInfoHeaderButtonsParams) => {
  const { isDisabled, disablePrintBarcode, rmLite, barcodeActionsList } = params;
  const infoHeaderButtons: Array<RMCustomButtonProps> = rmLite
    ? []
    : [
        {
          iconProps: {
            name: 'PrintBarcode',
            fill: headerButtonsColor,
            ...headerIconSize,
          },
          title: 'Barcode',
          isDisabled: isDisabled || disablePrintBarcode,
          dropDownList: barcodeActionsList,
          color: headerButtonsColor,
          showChevronIcon: true,
          chevronIconInitialAngle: 315,
          chevronIconPosition: 'end',
          contentOrientation: 'Vertical',
          contentContainerClass: 'header-button-container main-header-extended-button',
          titleClass: 'header-button-title',
        },
      ];
  return infoHeaderButtons;
};

export const getReportsButtonsList = (params: GetReportsButtonsListParams) => {
  const {
    setReportType,
    usageStatLogger,
    accessRightName,
    licenseAuthCommand,
    exportFrapDataPoints,
    disableFrapExport,
  } = params;
  const reportsList: IDropDownList[] = [
    {
      label: 'Instant Drop',
      iconProps: {
        subfolder: 'Reports',
        name: 'InstantDropReport',
        fill: DropDownListButtonsColor,
      },
      onClick: licenseAuthCommand((e) => {
        setReportType(EReportTypes.InstantDropReport);
        usageStatLogger('Report.' + e.target.textContent);
      }, EUserAction.InstantDropReport),
      isDisabled: !hasModifyAccess(accessRightName),
    },
    {
      label: 'Experiment',
      iconProps: {
        subfolder: 'Reports',
        name: 'ExperimentReport',
        fill: DropDownListButtonsColor,
      },
      onClick: licenseAuthCommand((e) => {
        setReportType(EReportTypes.ExperimentReport);
        usageStatLogger('Report.' + e.target.textContent);
      }, EUserAction.ExperimentReport),
      isDisabled: !hasModifyAccess(accessRightName),
    },
    {
      label: 'Design',
      iconProps: {
        subfolder: 'Reports',
        name: 'DesignReport',
        fill: DropDownListButtonsColor,
      },
      onClick: licenseAuthCommand((e) => {
        setReportType(EReportTypes.DesignReport);
        usageStatLogger('Report.' + e.target.textContent);
      }, EUserAction.DesignReport),
      isDisabled: !hasModifyAccess(accessRightName),
    },
    {
      label: 'Ingredient',
      iconProps: {
        subfolder: 'Reports',
        name: 'IngredientReport',
        fill: DropDownListButtonsColor,
      },
      onClick: licenseAuthCommand((e) => {
        setReportType(EReportTypes.IngredientReport);
        usageStatLogger('Report.' + e.target.textContent);
      }, EUserAction.IngredientReport),
      isDisabled: !hasModifyAccess(accessRightName),
    },
    {
      label: 'Image',
      iconProps: {
        subfolder: 'Reports',
        name: 'ImageReport',
        fill: DropDownListButtonsColor,
      },
      isDisabled: !hasModifyAccess(accessRightName),
      onClick: licenseAuthCommand((e) => {
        setReportType(EReportTypes.ImageReport);
        usageStatLogger('Report.' + e.target.textContent);
      }, EUserAction.ImageReport),
    },
    {
      label: 'Single Drop',
      iconProps: {
        subfolder: 'Reports',
        name: 'SingleDropReport',
        fill: DropDownListButtonsColor,
      },
      isDisabled: !hasModifyAccess(accessRightName),
      onClick: licenseAuthCommand((e) => {
        setReportType(EReportTypes.SingleDropReport);
        usageStatLogger('Report.' + e.target.textContent);
      }, EUserAction.SingleDropReport),
    },
    {
      label: 'Well',
      iconProps: {
        subfolder: 'Reports',
        name: 'WellReport',
        fill: DropDownListButtonsColor,
      },
      isDisabled: !hasModifyAccess(accessRightName),
      onClick: licenseAuthCommand((e) => {
        setReportType(EReportTypes.WellReport);
        usageStatLogger('Report.' + e.target.textContent);
      }, EUserAction.WellReport),
    },
    {
      label: 'Synchrotron Trip',
      iconProps: {
        subfolder: 'Reports',
        name: 'WellReport',
        fill: DropDownListButtonsColor,
      },
      isDisabled: !hasModifyAccess(accessRightName),
      onClick: licenseAuthCommand((e) => {
        setReportType(EReportTypes.SynchrotronTripReport);
        usageStatLogger('Report.' + e.target.textContent);
      }, EUserAction.SynchrotronTripReport),
    },
    {
      label: 'Score',
      iconProps: {
        subfolder: 'Reports',
        name: 'ScoreReport',
        fill: DropDownListButtonsColor,
      },
      onClick: licenseAuthCommand((e) => {
        setReportType(EReportTypes.ScoreReport);
        usageStatLogger('Report.' + e.target.textContent);
      }, EUserAction.ScoreReport),
      isDisabled: !hasModifyAccess(accessRightName),
    },
    {
      label: 'Export Frap Data Point',
      iconProps: {
        subfolder: 'Reports',
        name: 'FRAPDataPoints',
        fill: DropDownListButtonsColor,
      },
      onClick: (e) => {
        exportFrapDataPoints();
        usageStatLogger('Report.' + e.target.textContent);
      },
      isDisabled: disableFrapExport,
    },
    {
      label: 'Screen Stock',
      iconProps: {
        subfolder: 'Reports',
        name: 'IngredientReport',
        fill: DropDownListButtonsColor,
      },
      onClick: licenseAuthCommand((e) => {
        setReportType(EReportTypes.ScreenStockReport);
        usageStatLogger('Report.' + e.target.textContent);
      }, EUserAction.ScreenStockReport),
      isDisabled: !hasModifyAccess(accessRightName),
    },
  ];
  return reportsList;
};

export const getScreenDesignExtraButtonsList = (
  params: GetScreenDesignExtraButtonsListParams,
) => {
  const { accessRightName, setFileImportActionType, setFileExportActionType } = params;
  const extraOptionsList: IDropDownList[] = [
    {
      label: 'Import XML Screen',
      iconProps: { name: 'Import', fill: DropDownListButtonsColor },
      onClick: () => {
        setFileImportActionType(EFileImportTypes.XMLSCREEN);
      },
      isDisabled: !hasModifyAccess(accessRightName),
    },
    {
      label: 'Export XML Screen',
      iconProps: { name: 'Export', fill: DropDownListButtonsColor },
      onClick: () => {
        setFileExportActionType(EFileExportTypes.XMLSCREEN);
      },
      isDisabled: !hasModifyAccess(accessRightName),
    },
    {
      label: 'Export Selected Well (TXT)',
      iconProps: { name: 'Export', fill: DropDownListButtonsColor },
      onClick: () => {
        setFileExportActionType(EFileExportTypes.Text);
      },
      isDisabled: !hasModifyAccess(accessRightName),
    },
  ];
  return extraOptionsList;
};

export const getScreenDesignHeaderButtons = (
  params: GetScreenDesignHeaderButtonsParams,
) => {
  const {
    accessRightName,
    addLayerList,
    reportsList,
    setFileExportActionType,
    setFileImportActionType,
    showOptimizationModal,
    isDisabled,
    rotateCanvas,
    disablePrintBarcode,
    printActionsList,
  } = params;
  const designExtraButtonsList = getDesignExtraButtonsList({
    accessRightName,
    isEditMode: true,
    setFileImportActionType,
    setFileExportActionType,
    isDisabled,
    rotateCanvas,
    isScreenExperiment: true,
  });

  const designHeaderButtons: Array<RMCustomButtonProps> = [
    {
      iconProps: { name: 'AddLayer', fill: headerButtonsColor, ...headerIconSize },
      title: 'Add Layer',
      isDisabled: isDisabled,
      dropDownList: addLayerList.filter((item) => validLayers.includes(item.label)),
      color: headerButtonsColor,
      showChevronIcon: true,
      chevronIconInitialAngle: 315,
      chevronIconPosition: 'end',
      contentOrientation: 'Vertical',
      contentContainerClass: 'header-button-container main-header-extended-button',
      titleClass: 'header-button-title',
    },
    {
      iconProps: { name: 'PrintBarcode', fill: headerButtonsColor, ...headerIconSize },
      title: 'Barcode',
      isDisabled: isDisabled || disablePrintBarcode,
      dropDownList: printActionsList,
      color: headerButtonsColor,
      showChevronIcon: true,
      chevronIconInitialAngle: 315,
      chevronIconPosition: 'end',
      contentOrientation: 'Vertical',
      contentContainerClass: 'header-button-container main-header-extended-button',
      titleClass: 'header-button-title',
    },
    {
      iconProps: { name: 'Optimize', fill: headerButtonsColor, ...headerIconSize },
      title: 'Optimize',
      isDisabled: isDisabled || !hasModifyAccess(accessRightName),
      contentOrientation: 'Vertical',
      contentContainerClass: 'header-button-container',
      titleClass: 'header-button-title',
      onClick: showOptimizationModal,
    },
    {
      iconProps: {
        subfolder: 'Reports',
        name: 'Report',
        fill: headerButtonsColor,
        ...headerIconSize,
      },
      title: 'Reports',
      isDisabled: isDisabled,
      dropDownList: reportsList.filter((item) => screenReports.includes(item.label)),
      color: headerButtonsColor,
      showChevronIcon: true,
      chevronIconInitialAngle: 315,
      chevronIconPosition: 'end',
      contentOrientation: 'Vertical',
      contentContainerClass: 'header-button-container main-header-extended-button',
      titleClass: 'header-button-title',
    },
    {
      iconProps: { name: 'ThreeDotMenu', fill: headerButtonsColor, ...headerIconSize },
      title: 'More',
      isDisabled: isDisabled,
      dropDownList: designExtraButtonsList.filter(
        (item) => item.label !== 'Convert To Screen',
      ),
      color: headerButtonsColor,
      showChevronIcon: true,
      chevronIconInitialAngle: 315,
      chevronIconPosition: 'end',
      contentOrientation: 'Vertical',
      contentContainerClass: 'header-button-container main-header-extended-button',
      titleClass: 'header-button-title',
    },
  ];

  return designHeaderButtons;
};

export const getWellImageExtraActions = (params: GetWellImageExtraActionsParams) => {
  const {
    accessRightName,
    saveImage,
    setFileExportActionType,
    exportPoi,
    isDropImageAvailable,
  } = params;
  const ImageHeaderExtraButtons: IDropDownList[] = [
    {
      label: 'Manage Imaging',
      iconProps: { name: 'ImageManage', fill: DropDownListButtonsColor },
      onClick: () => {},
      isDisabled: true,
    },
    {
      label: 'Save',
      iconProps: { name: 'SaveImage', fill: DropDownListButtonsColor },
      onClick: saveImage,
      isDisabled: !isDropImageAvailable,
    },
    {
      label: 'Export POI',
      iconProps: { name: 'ExportPOI', fill: DropDownListButtonsColor },
      subMenu: getPoiExportSubMenu(exportPoi),
    },
    {
      label: 'Export XML Screen',
      iconProps: { name: 'Export', fill: DropDownListButtonsColor },
      onClick: () => {
        setFileExportActionType(EFileExportTypes.XMLSCREEN);
      },
      isDisabled: !hasModifyAccess(accessRightName),
    },
    {
      label: 'Export Selected Well (TXT)',
      iconProps: { name: 'Export', fill: DropDownListButtonsColor },
      onClick: () => {
        setFileExportActionType(EFileExportTypes.Text);
      },
      isDisabled: !hasModifyAccess(accessRightName),
    },
  ];
  return ImageHeaderExtraButtons;
};

export const getWellImageHeaderButtons = (params: GetWellImageHeaderButtonsParams) => {
  const {
    isCompareMode,
    isWellMode,
    compareModeHandler,
    accessRightName,
    ShowOptimizeModalHandler,
    createSeedHandler,
    saveImage,
    reportsList,
    setFileExportActionType,
    isDisabled,
    getDisableImageLabel,
    setRegionImaging,
    rmLite,
    exportPoi,
    isDropImageAvailable,
    selectedCompareMode,
  } = params;
  const wellImageExtraActions = getWellImageExtraActions({
    accessRightName,
    saveImage,
    setFileExportActionType,
    getDisableImageLabel,
    setRegionImaging,
    exportPoi,
    isDropImageAvailable,
  });
  const compareList = getViewByList(compareModeHandler, selectedCompareMode, isWellMode);

  if (rmLite) {
    return [
      {
        title: 'Save',
        isDisabled: isDisabled || !isDropImageAvailable,
        iconProps: { name: 'SaveImage', fill: headerButtonsColor, ...headerIconSize },
        contentOrientation: 'Vertical',
        contentContainerClass: 'header-button-container',
        titleClass: 'header-button-title',
        onClick: saveImage,
      },
      (isCompareMode || isWellMode) && {
        title: isWellMode ? 'View' : 'Compare',
        isDisabled: isDisabled,
        iconProps: { name: 'CompareMode', fill: headerButtonsColor, ...headerIconSize },
        dropDownList: compareList,
        color: headerButtonsColor,
        showChevronIcon: true,
        chevronIconInitialAngle: 315,
        chevronIconPosition: 'end',
        contentOrientation: 'Vertical',
        contentContainerClass: 'header-button-container main-header-extended-button',
        titleClass: 'header-button-title',
      },
    ];
  }

  const wellImageHeaderButtons: Array<RMCustomButtonProps> = [
    {
      title: 'Seed',
      isDisabled: isDisabled,
      iconProps: { name: 'AddSeed', fill: headerButtonsColor, ...headerIconSize },
      contentOrientation: 'Vertical',
      contentContainerClass: 'header-button-container',
      titleClass: 'header-button-title',
      onClick: createSeedHandler,
    },
    (isCompareMode || isWellMode) && {
      title: isWellMode ? 'View' : 'Compare',
      isDisabled: isDisabled,
      iconProps: { name: 'CompareMode', fill: headerButtonsColor, ...headerIconSize },
      dropDownList: compareList,
      color: headerButtonsColor,
      showChevronIcon: true,
      chevronIconInitialAngle: 315,
      chevronIconPosition: 'end',
      contentOrientation: 'Vertical',
      contentContainerClass: 'header-button-container main-header-extended-button',
      titleClass: 'header-button-title',
    },
    {
      title: 'Optimize',
      isDisabled: isDisabled || !hasModifyAccess(accessRightName),
      iconProps: { name: 'Optimize', fill: headerButtonsColor, ...headerIconSize },
      contentOrientation: 'Vertical',
      contentContainerClass: 'header-button-container',
      titleClass: 'header-button-title',
      onClick: ShowOptimizeModalHandler,
    },
    {
      iconProps: {
        subfolder: 'Reports',
        name: 'Report',
        fill: headerButtonsColor,
        ...headerIconSize,
      },
      title: 'Reports',
      isDisabled: isDisabled,
      dropDownList: reportsList.filter((item) => item.label != screenStockReportLabel),
      color: headerButtonsColor,
      showChevronIcon: true,
      chevronIconInitialAngle: 315,
      chevronIconPosition: 'end',
      contentOrientation: 'Vertical',
      contentContainerClass: 'header-button-container main-header-extended-button',
      titleClass: 'header-button-title',
    },
    {
      iconProps: { name: 'ThreeDotMenu', fill: headerButtonsColor, ...headerIconSize },
      title: 'More',
      isDisabled: isDisabled,
      dropDownList: wellImageExtraActions,
      color: headerButtonsColor,
      showChevronIcon: true,
      chevronIconInitialAngle: 315,
      chevronIconPosition: 'end',
      contentOrientation: 'Vertical',
      contentContainerClass: 'header-button-container main-header-extended-button',
      titleClass: 'header-button-title',
    },
  ];

  return wellImageHeaderButtons;
};

export const getIngredientHeaderButtons = (params: GetIngredientHeaderButtonsParams) => {
  const { printBarcode, isDisabled } = params;
  const infoHeaderButtons: Array<RMCustomButtonProps> = [
    {
      iconProps: { name: 'EditExperiment', fill: headerButtonsColor, ...headerIconSize },
      title: 'Create New Ingredient',
      isDisabled: true,
      contentOrientation: 'Vertical',
      contentContainerClass: 'header-button-container',
      titleClass: 'header-button-title',
      onClick: () => {},
    },
    {
      iconProps: { name: 'Barcode', fill: headerButtonsColor, ...headerIconSize },
      title: 'Merge Ingredient',
      isDisabled: isDisabled,
      contentOrientation: 'Vertical',
      contentContainerClass: 'header-button-container',
      titleClass: 'header-button-title',
      onClick: printBarcode,
    },
    {
      iconProps: { name: 'Barcode', fill: headerButtonsColor, ...headerIconSize },
      title: 'Liquid Class',
      isDisabled: isDisabled,
      contentOrientation: 'Vertical',
      contentContainerClass: 'header-button-container',
      titleClass: 'header-button-title',
      onClick: () => {},
    },
    {
      iconProps: { name: 'Barcode', fill: headerButtonsColor, ...headerIconSize },
      title: 'Ingredient Type',
      isDisabled: isDisabled,
      contentOrientation: 'Vertical',
      contentContainerClass: 'header-button-container',
      titleClass: 'header-button-title',
      onClick: () => {},
    },
    {
      iconProps: { name: 'Barcode', fill: headerButtonsColor, ...headerIconSize },
      title: 'Vendor',
      isDisabled: isDisabled,
      contentOrientation: 'Vertical',
      contentContainerClass: 'header-button-container',
      titleClass: 'header-button-title',
      onClick: () => {},
    },
    {
      iconProps: { name: 'Barcode', fill: headerButtonsColor, ...headerIconSize },
      title: 'Print Label',
      isDisabled: isDisabled,
      contentOrientation: 'Vertical',
      contentContainerClass: 'header-button-container',
      titleClass: 'header-button-title',
      onClick: () => {},
    },
    {
      iconProps: { name: 'Barcode', fill: headerButtonsColor, ...headerIconSize },
      title: 'Import',
      isDisabled: isDisabled,
      contentOrientation: 'Vertical',
      contentContainerClass: 'header-button-container',
      titleClass: 'header-button-title',
      onClick: () => {},
    },
    {
      iconProps: { name: 'Barcode', fill: headerButtonsColor, ...headerIconSize },
      title: 'Export',
      isDisabled: isDisabled,
      contentOrientation: 'Vertical',
      contentContainerClass: 'header-button-container',
      titleClass: 'header-button-title',
      onClick: () => {},
    },
  ];
  return infoHeaderButtons;
};
export const getRMCustomButton = (
  iconName: RMSvgIconNames,
  width: number,
  height: number,
  isDisabled: boolean,
  onClick: () => void,
  showBorder: boolean,
  customStyle: React.CSSProperties,
  buttonMainContainerStyle: React.CSSProperties,
) => {
  return {
    iconProps: { name: iconName, width: width, height: height },
    isDisabled: isDisabled,
    onClick: onClick,
    showBorder: showBorder,
    customStyle: customStyle,
    buttonMainContainerStyle: buttonMainContainerStyle,
  } as RMCustomButtonProps;
};

export const getSuggestedRotatedScreenName = (screenName: string): string => {
  const rotationSuffix = experiment.RotateExpName;
  const existingSuffix = screenName.match(RotatedScreenNameRegex.name)?.[0] ?? '';
  const baseName = screenName.slice(0, screenName.length - existingSuffix.length);
  const generatedSuffix = existingSuffix + rotationSuffix;
  const maxBaseNameLength = TreeNode.TreeNodeNameMaxLength - generatedSuffix.length;

  return (
    baseName.slice(0, Math.max(0, maxBaseNameLength)).replace(/_$/, '') + generatedSuffix
  );
};

export const RotateScreenCanvas = async (
  layers,
  isDirty,
  platesLength,
  treeNodeId,
  showRotateCanvasMessageBox,
  updatedProperties,
  showModal,
  showLoadingModal,
  hideModal,
  body,
  screenName,
  getNewScreenName,
) => {
  const customLayer = layers.filter(
    (layer: any) =>
      layer.type === LayerTypeDTO.ConditionList &&
      layer.layerDetail?.condition.length === 96,
  ) as any;
  const maxConditions = (customLayer[0]?.height + 1) * (customLayer[0]?.width + 1);
  if (isDirty) {
    showAlertSnackBar(
      EAlertType.ERROR,
      ESnackBarPosition.TOP,
      'Please save experiment to perform this action',
    );
  } else if (platesLength > 1) {
    showAlertSnackBar(
      EAlertType.ERROR,
      ESnackBarPosition.TOP,
      'There must be single plate to perform this action',
    );
  } else if (
    maxConditions < 96 ||
    layers.length > 1 ||
    !customLayer?.length ||
    customLayer.length > 1
  ) {
    showAlertSnackBar(
      EAlertType.ERROR,
      ESnackBarPosition.TOP,
      'There must be 96 conditions present in only one custom layer to perform this action',
    );
  } else {
    const hasNameLengthWarning =
      screenName.endsWith(experiment.RotateExpName) ||
      `${screenName}${experiment.RotateExpName}`.length > TreeNode.TreeNodeNameMaxLength;

    if (!showRotateCanvasMessageBox || hasNameLengthWarning) {
      await showModal({
        body: body,
        onOk: () =>
          PerformRotation(
            treeNodeId,
            updatedProperties,
            showLoadingModal,
            hideModal,
            getNewScreenName?.(),
            screenName,
          ),
        heading: 'Rotate Canvas',
      });
    } else {
      PerformRotation(
        treeNodeId,
        updatedProperties,
        showLoadingModal,
        hideModal,
        getNewScreenName?.(),
        screenName,
      );
    }
  }
};

export const PerformRotation = async (
  treeNodeId,
  updatedProperties,
  showLoadingModal,
  hideModal,
  newScreenName,
  sourceScreenName,
) => {
  const parentId = await new TreeService().getParentIdByTreeNodeId(treeNodeId);
  showLoadingModal('Rotating Screen');

  const rotateScreenDTO: RotateScreenDTO = new RotateScreenDTO();
  rotateScreenDTO.treeNodeId = treeNodeId;
  rotateScreenDTO.treeNodeParentId = parentId;

  if (updatedProperties?.length) {
    const service = new GlobalPreferencesService();
    const preferences = new PreferenesDTO();
    preferences.baseProperties = updatedProperties;
    preferences.preferenceType = 'user';
    await service.setAllProperties(preferences);
  }

  const treeNodeDTOList: CreateNewTreeNodeDTO[] = await new ScreenService().rotateScreen([
    rotateScreenDTO,
  ]);
  if (treeNodeDTOList[0] === null) {
    return null;
  }
  let rotatedScreenName = newScreenName?.trim();
  const suggestedRotatedScreenName = sourceScreenName
    ? getSuggestedRotatedScreenName(sourceScreenName)
    : undefined;
  const backendGeneratedDifferentName =
    rotatedScreenName &&
    suggestedRotatedScreenName === rotatedScreenName &&
    treeNodeDTOList[0].name !== suggestedRotatedScreenName;

  if (backendGeneratedDifferentName) {
    rotatedScreenName = treeNodeDTOList[0].name;
  } else if (rotatedScreenName) {
    await new TreeService().renameNode(treeNodeDTOList[0].id, rotatedScreenName);
    treeNodeDTOList[0].name = rotatedScreenName;
  }
  const screenUrl = `/screen/${treeNodeDTOList[0].expId}`;
  const rotatedScreenUrl = rotatedScreenName
    ? `${screenUrl}?rotatedName=${encodeURIComponent(rotatedScreenName)}`
    : screenUrl;
  window.open(rotatedScreenUrl, screenUrl);
  hideModal();
  return treeNodeDTOList[0];
};

export const isMotherPlateEnabled = async (
  motherPlatesScoringStatuses: { [plateId: string]: boolean },
  selectedWellDetails: WellNavigationDetails[],
  showModal,
) => {
  for (const w of selectedWellDetails) {
    const isMotherPlateEnabled: boolean = motherPlatesScoringStatuses[w.plateID];
    if (!isMotherPlateEnabled) {
      showModal({
        body: 'Scoring mother plate of iterative screen optimized experiment is disabled. \nPlease enable scoring mother plate General Preferences and try again.',
        showButtons: false,
        heading: 'ROCK MAKER Scoring',
      });
      return false;
    }
  }
  return true;
};

export const hasImagedWell = (
  selectedWellDetails: WellNavigationDetails[],
  imagedWells: PlateWellDTO[],
) =>
  selectedWellDetails?.some((well) =>
    imagedWells?.some(
      (imaged) => imaged.plateId === well?.plateID && imaged.wellNumber === well?.wellNum,
    ),
  );

export const isScoringWithoutImagesEnabled = async (
  selectedWellDetails: WellNavigationDetails[],
  imagedWells: PlateWellDTO[],
) => {
  if (hasImagedWell(selectedWellDetails, imagedWells)) {
    return true;
  }

  const gpService: GlobalPreferencesService = new GlobalPreferencesService();
  const property = (await gpService.getProperty(
    PropertyConstants.ScoreWithoutImages,
  )) as BooleanPropertyDTO;
  return property.value;
};

export const getAvailableCpIds = (
  navigatorMap: NavigatorMapDTO,
  dropNumber: number,
  inspectionId: number,
  regionName: string,
) => {
  return navigatorMap?.drciList
    ?.filter(
      (item) =>
        item.drc.dropNumber === dropNumber &&
        item.drc.regionName === regionName &&
        item.inspectedWells.some(
          (inspection) =>
            inspection.inspectionId === inspectionId && inspection.wells.length > 0,
        ),
    )
    .map((item) => item.drc.cpId);
};

export const getAvailableInspectionSets = (
  navigatorMap: NavigatorMapDTO,
  plateId: number,
  cpId: number,
  dropNumber: number,
  regionName: string,
) => {
  const availableImageBatchIds = navigatorMap?.drciList
    ?.filter(
      (item) =>
        item.drc.cpId === cpId &&
        item.drc.dropNumber === dropNumber &&
        item.drc.regionName === regionName,
    )
    ?.flatMap((item) =>
      item.inspectedWells
        .filter(
          (inspection) =>
            inspection.wells.length > 0 &&
            inspection.wells.some((well) => well.plateId === plateId),
        )
        .map((inspection) => inspection.inspectionId),
    );
  if (!availableImageBatchIds) {
    return [];
  }
  return navigatorMap?.inspectionSetList
    ?.filter((set) =>
      set.groupedInspections.some((inspection) =>
        availableImageBatchIds.includes(inspection.imageBatchId),
      ),
    )
    .sort((a, b) => {
      const dateA = new Date(a.dateImaged).getTime();
      const dateB = new Date(b.dateImaged).getTime();
      return dateB - dateA;
    });
};

export function GetExperimentCanvasWidth(
  widthMainDiv: number,
  windowInnerWidth: number,
): number {
  // Subtracting 4.7 % from main width for the Main left Route Panel
  // Subtracting 60px for the left mode panel
  return (windowInnerWidth - windowInnerWidth * 0.02 - 66) * (widthMainDiv / 100) - 20;
}

export function GetExperimentCanvasHeight(windowInnerHeight: number): number {
  // Subtracting Two time header height (Including Bottom Menu)
  return windowInnerHeight - GetHeaderHeight() * 2;
}
